import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  TransferRequestDialog,
  TransferRequestDialogCallbackInput,
  TransferRequestUniqueProps,
} from '../TransferRequestHookDialog';

const { useDialogForContext, useDialog: useTransferRequestDialog } =
  getDialogHooks<
    TransferRequestUniqueProps,
    TransferRequestDialogCallbackInput
  >(TransferRequestDialog);
export const useTransferRequestDialogForContext = useDialogForContext;
export default useTransferRequestDialog;
